// Keep receipt time for audit/duration; use gameplay time for dates and ordering.
export const frameStatisticsTimestamp = frame => frame?.played_at || frame?.created_at;

export const statisticsTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

export const statisticsRange = (now = new Date(), dayOffset = 0) => {
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 7);
    if (now < start) start.setDate(start.getDate() - 1);
    start.setDate(start.getDate() + dayOffset);
    const end = new Date(start);
    end.setDate(end.getDate() + 1);
    return { start, end };
};

export const formatStatisticsInput = date => {
    const pad = number => String(number).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

// datetime-local has no zone. Send the selected instant, not an ambiguous string.
export const statisticsApiDate = value => new Date(value).toISOString();
